import type { GAIAConfig } from "@vectorlab-cg/gaia";

export default function getGaiaConfig(canvas: HTMLCanvasElement): GAIAConfig {
    const urlParams = new URLSearchParams(window.location.search);
    const gaiaLang = urlParams.get('gaia-lang');
    const VALID_LANGUAGES = ["en-US", "it-IT", "es-ES", "fr-FR", "de-DE"] as const;
    const language = (VALID_LANGUAGES.includes(gaiaLang as any) ? gaiaLang : "en-US") as any;

    return {
        reasoner: { type: "default", config: { socketUrl: "wss://api.vectorlab-cg.com/llm/vectorlab" } },
        inputComponents: [
            {
                type: "text",
                config: { elementId: "gaia-input" }
            },
        ],
        outputComponents: [
            {
                type: "avatar",
                config: {
                    ttsEndpoint: "https://api.vectorlab-cg.com/tts/cartesia",
                    language: language,
                    scene: {
                        canvas: canvas,
                        model: "https://gaia-assets.vectorlab-cg.com/gaia/avatar.fbx",
                        transparent: true,
                        expressionsUrl: "https://gaia-assets.vectorlab-cg.com/gaia/expressions.json",
                        debug: false,
                        camera: {
                            position: {
                                x: 0.35,
                                y: 1.75,
                                z: -1.60,
                            },
                            target: {
                                x: -0.05,
                                y: -0.25,
                                z: -1.25,
                            },
                        },
                        animationMap: {
                            "Idle": {
                                url: ["https://gaia-assets.vectorlab-cg.com/gaia/animations/idle.fbx"]
                            },
                            "Listen": {
                                url: ["https://gaia-assets.vectorlab-cg.com/gaia/animations/listen.fbx"]
                            },
                            "Think": {
                                url: ["https://gaia-assets.vectorlab-cg.com/gaia/animations/think.fbx"]
                            },
                            "Talk": {
                                url: ["https://gaia-assets.vectorlab-cg.com/gaia/animations/talk.fbx"]
                            },
                            "QuickThink": {
                                url: ["https://gaia-assets.vectorlab-cg.com/gaia/animations/quickthink.fbx"]
                            },
                        },
                    },
                },
            },
        ],
    };
};
